import { render, staticRenderFns } from "./LoaderOverScreen.vue?vue&type=template&id=6e968b61&"
import script from "./LoaderOverScreen.vue?vue&type=script&lang=js&"
export * from "./LoaderOverScreen.vue?vue&type=script&lang=js&"
import style0 from "./LoaderOverScreen.vue?vue&type=style&index=0&id=6e968b61&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports